// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IeSquareFilledSvg from "@ant-design/icons-svg/es/asn/IeSquareFilled";
import AntdIcon from '../components/AntdIcon';

var IeSquareFilled = function IeSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: IeSquareFilledSvg
  }));
};

IeSquareFilled.displayName = 'IeSquareFilled';
export default React.forwardRef(IeSquareFilled);